import { CustomNumber } from '../../CustomNumber/CustomNumber';
import { Icon } from '../../UI';

export const PieCenter = ({
  id,
  percentage,
  value,
  handlePieCenter,
  symbol,
}: {
  id?: string;
  percentage: string;
  symbol: string;
  value: number;
  handlePieCenter(param: number): void;
}) => (
  <div
    className={`
      flex
      flex-col
      items-center
      justify-center
      absolute
      top-1/2
      left-1/2
      right-1/2
      bottom-1/2
      z-30
    `}
  >
    <div className="flex flex-col items-center w-52">
      <span className="text-grey-50">{id}</span>

      <div className="flex items-center w-full px-3">
        <Icon
          className="flex mr-auto text-grey-50 cursor-pointer"
          svgName="navigateBefore"
          onClick={() => handlePieCenter(-1)}
        />

        <span className="text-3xl font-bold flex">{percentage}%</span>

        <Icon
          className="ml-auto text-grey-50 cursor-pointer"
          svgName="navigateNext"
          onClick={() => handlePieCenter(1)}
        />
      </div>

      <CustomNumber
        className="cursor-default text-sm text-center"
        prefix={'( '}
        suffix={symbol + ' )'}
        value={value}
        displayType={'text'}
      />
    </div>
  </div>
);
